import {
  SET_ADOPT_DATA,
  ADOPT_SESSION_FETCHING_INIT,
  ADOPT_REGNS_FETCHING_INIT,
  ADOPT_SUMMARY_PLANS_FETCHING_INIT,
} from "./types";

const initialState = {
  session_list: [],
  total_sessions: 0,
  session_page: 1,
  session_perpage: 20,
  session_search: "",
  session_list_refetch: false,
  session_list_refetch_force: false,
  create_session_popup: false,
  C_session_name: "",
  C_partner: "",
  C_session_date: new Date(),
  C_report_type: "",
  C_distributor: "",
  C_temp_session: false,
  C_discounted: false,
  C_session_info: null,
  is_partner_disabled: false,
  file_upload_percentage: 0,
  C_partner_name: "",
  C_file: null,
  C_selected_partner: null,
  C_selected_report: null,
  edit_session_popup: false,
  Ed_session_name: "",
  Ed_partner: "",
  Ed_session_date: new Date(),
  Ed_report_type: "",
  Ed_distributor: "",
  Ed_temp_session: false,
  Ed_discounted: false,
  Ed_session_id: null,
  Ed_session_details: null,
  disable_session_edit_btn: false,
  is_partner_edit_disabled: false,
  delete_session_popup: false,
  Del_session_details: null,
  del_btn_disable: false,
  report_types: [],
  partner_list: [],
  distributer_list: [],
  disable_session_add_btn: false,
  isDataLoading: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ADOPT_DATA:
      return { ...state, ...action.payload };
    case ADOPT_SESSION_FETCHING_INIT: {
      return {
        ...state,
        session_list_refetch: false,
        session_list_refetch_force: false,
        isDataLoading: true,
      };
    }
    case ADOPT_REGNS_FETCHING_INIT: {
      return {
        ...state,
        registrations_list_refetch: false,
        registrations_list_refetch_force: false,
        isDataLoading: true,
      };
    }
    case ADOPT_SUMMARY_PLANS_FETCHING_INIT: {
      return {
        ...state,
        summaryPlans_Refetch: false,
        isDataLoading: true,
        isSummaryPlansLoading: true,
      };
    }
    default:
      return state;
  }
};
